import { useConfigStore } from '@/js/stores/configStore'
import { useCustomerStore } from '@/js/stores/customerStore'
import { usePaymentMethodStore } from '@/js/stores/paymentMethodStore'
import { cardToPayment } from '@/js/components/payment/util'
import type { OrderConfig, WebOrderPayment } from '@orders'
import type { IOrderPayment } from '@rogue/universal'
import type { Address, CreditCard, IRogue } from '@/js/services/RogueTypes'

const defaultAdyenPayment: IOrderPayment & {adyenType: 'scheme'} = {
  paymentType      : 'adyen',
  adyenType        : 'scheme',
  transactionToken : '',
  amount           : 0,
}

export function getDefaultOrderConfig(rogue: IRogue): OrderConfig['default'] {
  const configStore = useConfigStore(rogue.pinia)
  const customerStore = useCustomerStore(rogue.pinia)
  const defaultAddress = configStore.defaultAddress(rogue)
  const addresses = customerStore.addresses
  const creditCards = customerStore.creditCards

  let adyenPayment: WebOrderPayment | undefined
  if (rogue.adyenCheckout) {
    const paymentMethodStore = usePaymentMethodStore(rogue.pinia)
    adyenPayment = paymentMethodStore.savedMethods.find(pm => pm.isDefault) || paymentMethodStore.savedMethods[0] || defaultAdyenPayment
  }

  const card:CreditCard = creditCards.find((cc:CreditCard) => cc.isDefault) || creditCards[0]
  const billing = addresses.find((addr:Address) => addr._id === card?.billingAddressId)

  const shipping = addresses.find((addr) => addr.isDefaultShipping) as Address

  return {
    customer : { email: customerStore.email || '', groupId: customerStore.groupId },
    shipping : shipping || defaultAddress,
    billing  : billing || defaultAddress,
    payment  : rogue.adyenCheckout ? adyenPayment : { ...cardToPayment(card), adyenType: '' },
  }
}
